import { useState, useEffect, createContext, useContext } from 'react';
import { apiGet } from '../api/apiClient';

const TenantContext = createContext({
  displayName: 'RentTick',
  loading: true,
});

export function TenantProvider({ children }) {
  const [tenantInfo, setTenantInfo] = useState({ displayName: 'RentTick', loading: true });

  useEffect(() => {
    apiGet('/tenant/info', { timeout: 10000 })
      .then(res => {
        setTenantInfo({
          displayName: res.data.display_name || 'RentTick',
          appHostUrl: res.data.app_host_url || '',
          loading: false,
        });
        // Update document title
        if (res.data.display_name) {
          document.title = `${res.data.display_name} | RentTick`;
        }
      })
      .catch(() => {
        setTenantInfo(prev => ({ ...prev, loading: false }));
      });
  }, []);

  return (
    <TenantContext.Provider value={tenantInfo}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenantInfo() {
  return useContext(TenantContext);
}

export default TenantContext;
